import { render } from "./SelectionApp.vue?vue&type=template&id=2d98ba30&scoped=true"
import script from "./SelectionApp.vue?vue&type=script&lang=js"
export * from "./SelectionApp.vue?vue&type=script&lang=js"

import "./SelectionApp.vue?vue&type=style&index=0&id=2d98ba30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d98ba30"]])

export default __exports__